import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";

//UI
import { Form, Divider, Header, Loader, Button, Breadcrumb, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

// Resources
import { scrollToTop } from "../../resources/utils";
import { fetchFlight, initialStateFlight} from "../../../redux/actions/catalogs/flight/fetchFlight";
import { fetchRoutes } from "../../../redux/actions/catalogs/route/fetchRoutes";
import { createRoutes } from "../../../redux/slices/custom/catalogs/flightRoutes/flightRoutes.slice";

export default function FlightRouteForm() {
  const { t } = useTranslation();
  let history = useHistory();
  let { flight_id } = useParams();
  const { register, handleSubmit, errors } = useForm();
  const flightState = useSelector((state) => state.flightReducer);
  const routeState = useSelector((state) => state.routeReducer);
  const { fetching, message, error } = useSelector((state) => state.flightRoute);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFlight(flight_id));
    dispatch(fetchRoutes());
    scrollToTop();
    return () => {
      dispatch(initialStateFlight());
    };
  }, []);

  if (routeState.fetching || flightState.fetching) {
    return <Loader active inline />;
  }

  const onSubmit = (data) => {
    dispatch(createRoutes(flight_id, data));
  };

  if (message === "resource created successfully") {
    history.go(-1);
  }

  return (
    <>
      {error ? (
        <Message negative content={t(error)} />
      ) : (
        ""
      )}
      <Breadcrumb>
        <Breadcrumb.Section><Link to="/flights" className="section">{t("flight_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/flight/${flight_id}/routes`} className="section">{flightState.flight.code}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active>{t("route_title")}</Breadcrumb.Section>
      </Breadcrumb>
      <Divider variant="fullWidth" />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("route_title")}</label>
            <select name="route_id" aria-expanded="true" ref={register({ required: true })}>
              <option></option>
              {routeState.routes.map((route, index) => (
                <option key={route.id} value={route.id}>
                  {route.origin_city} ({route.origin_code}) - {route.destination_city} ({route.destination_code})
                </option>
              ))}
            </select>
            {errors.availability && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
        </Form.Group>
        <Divider variant="middle" />

        <Button primary type="submit" loading={fetching ? true : false}>{t("save_button")}</Button>
        <Link to={`/flight/${flight_id}/routes`}><Button>{t("canceled_button")}</Button></Link>
      </Form>
    </>
  );
}
